import TranslationOfTextContentModelBase from '../_generated/modelBases/translation-of-text-content-model-base';

export default class TranslationOfTextContentModel extends TranslationOfTextContentModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
